import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { AnimatePresence } from "framer-motion";
import Preloader from "../../Components/Preloader";
import MainOfferPopup, {
  MainOffer,
} from "../../Components/offers/MainOfferPopup";
import Navbar from "../Menu/Navbar";
import Block1 from "./Sections/Block1";
import Blog from "./Sections/Blog";
import Brands from "./Sections/Brands";
import Care from "./Sections/Care";
import Footer from "./Sections/Footer";
import HeroSection from "./Sections/HeroSection";
import LoayalityProgram from "./Sections/LoayalityProgram";
import Says from "./Sections/Says";
import SearchCard from "./Sections/SearchCard";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../apis/store";
import {
  toSavePayment,
  toCapturePayment,
} from "../../apis/actions/paymentMethods.actions";
import { resetState, setShowPaiement } from "../../apis/slices/globalSlice";
import { toCreateAppointment } from "../../apis/actions/appointments.actions";
import { showNotitfication } from "../../utils/Utils";
import { useTranslation } from "react-i18next";
import RewardModal from "./Shop/RewardModal";
import { toGetOffers } from "../../apis/actions/offers.actions";

const Home = () => {
  const location = useLocation();
  const { t , i18n } = useTranslation();
  const hasRun = useRef(false);
  const [orderId, setOrderId] = useState("");
  const [retryAmount, seTRetryAmount] = useState(0);
  const [showRetry, SetShowRetry] = useState(false);
  const { profil } = useSelector((state: RootState) => state?.login);
  const { list: offers } = useSelector(
    (state: RootState) => state.offers.offers
  );
  const [rewardLoyalty, setRewardLoyalty] = useState("");
  const [dismissedMainOffer, setDismissedMainOffer] = useState<
    string | number | null
  >(null);
  const navigate = useNavigate();
  const { donationAmount } = useSelector((state: RootState) => state?.global);
  const dispatch = useDispatch<AppDispatch>();
  const { my_cart, loyaltyType, walletAmount } = useSelector(
    (state: RootState) => state?.global
  );
  const queryParams = new URLSearchParams(location.search);
  const cart_id = queryParams.get("cart_id");
  const amount = queryParams.get("amount");
  const payment_id = queryParams.get("payment_id");

  const mainOffer = useMemo(
    () =>
      (Array.isArray(offers)
        ? offers.find(
            (offer: MainOffer) =>
              offer.is_main === true ||
              offer.is_main === 1 ||
              offer.is_main === "true"
          )
        : undefined) as MainOffer | undefined,
    [offers]
  );
  const mainOfferKey = mainOffer?.id ?? mainOffer?.name ?? null;
  const closeMainOffer = useCallback(() => {
    if (mainOfferKey != null) setDismissedMainOffer(mainOfferKey);
  }, [mainOfferKey]);

  useEffect(() => {
    dispatch(toGetOffers(i18n.language));
  }, [dispatch, i18n.language]);

  useEffect(() => {
    if (
      cart_id &&
      cart_id !== "" &&
      !hasRun.current
    ) {
      hasRun.current = true;
      toSave(cart_id);
    }
  }, [cart_id]);
  const toSave = async (id: string) => {
    try {
      const captureResponse = (await dispatch(
        toCapturePayment({ payment_id, amount })
      )) as any;

      const captureStatus = captureResponse?.payload?.data?.result?.details;

      if (captureStatus?.status === "CLOSED") {
        const paymentData = {
          amount:
            Number(amount) + Number(donationAmount) - Number(walletAmount),
          transaction_id: payment_id,
          cart_id: cart_id,
          payment_type: "tabby",
          donation_amount: Number(donationAmount),
          loyalty_type: loyaltyType,
          wallet_amount: Number(walletAmount),
        };

        const response = (await dispatch(
          toSavePayment({ data: paymentData, lang: i18n.language })
        )) as any;
        const result = response?.payload?.data?.result;

        if (result?.code === 200) {
          if (result?.require_alternate_phone) {
            showNotitfication(
              t("profile.order.cart.successNotComplete"),
              "success"
            );
            setOrderId(result?.order_id);
            seTRetryAmount(result?.amount);
            setRewardLoyalty(loyaltyType);
            setTimeout(() => {
              SetShowRetry(true);
            }, 2800);
            toAddAppointment();
            dispatch(resetState());
            dispatch(setShowPaiement(false));
            return;
          }
          navigate("/profile", { state: { activeTab: 2 } });
          dispatch(setShowPaiement(false));
          toAddAppointment();
          dispatch(resetState());
        }
      } else {
        showNotitfication(captureStatus?.message, "error");
      }
    } catch (error) {
      showNotitfication("Capture or Save error for Tabby payment ", "error");
    }
  };

  const toAddAppointment = async () => {
    if (my_cart.service_ids.length > 0) {
      const success = (await dispatch(toCreateAppointment(my_cart))) as any;
      const response = success?.payload?.data?.result;

      if (response?.code === 200) {
        dispatch(resetState());
      } else {
      }
    }
  };

  return (
    <>
      <Navbar />
      <Preloader />
      <main className="main background-body ac-home-flow">
        <HeroSection />
        {/*
        <SearchCard />*/}
        <Block1 />
        <Blog />

        <Care />
        <LoayalityProgram />
        <Says />
        <Brands />
      </main>
      <Footer type="external" />
      <RewardModal
        open={showRetry}
        amount={retryAmount}
        order_id={orderId}
        loyaltyType={rewardLoyalty}
        onClose={() => SetShowRetry(false)}
      />
      <AnimatePresence>
        {mainOffer &&
          mainOfferKey !== null &&
          dismissedMainOffer !== mainOfferKey && (
            <MainOfferPopup offer={mainOffer} onClose={closeMainOffer} />
          )}
      </AnimatePresence>
    </>
  );
};

export default Home;
